export const CLIENT_ONLINE_BAGS_SORT_BY = [
  {
    field: 'firstName',
    order: 'asc',
    name: 'First Name: A-Z',
    value: 'firstNameAsc',
  },
  {
    field: 'firstName',
    order: 'desc',
    name: 'First Name: Z-A',
    value: 'firstNameDesc',
  },
  {
    field: 'lastName',
    order: 'asc',
    name: 'Last Name: A-Z',
    value: 'lastNameAsc',
  },
  {
    field: 'lastName',
    order: 'desc',
    name: 'Last Name: Z-A',
    value: 'lastNameDesc',
  },
  {
    field: 'ItemsAdded',
    order: 'asc',
    name: 'Items Added: Oldest-Newest',
    value: 'itemsAddedAsc',
  },
  {
    field: 'ItemsAdded',
    order: 'desc',
    name: 'Items Added: Newest-Oldest',
    value: 'itemsAddedDesc',
  },
];

export const DEFAULT_ONLINE_BAGS_SORT_BY = {
  field: 'ItemsAdded',
  order: 'desc',
};

export const DEFAULT_ONLINE_BAGS_FILTER_BY = '';

export default {
  CLIENT_ONLINE_BAGS_SORT_BY,
  DEFAULT_ONLINE_BAGS_SORT_BY,
  DEFAULT_ONLINE_BAGS_FILTER_BY,
};

export const CLIENT_ONLINE_BAG_FILTERS_BY = [
  {
    filterType: 'AddedToday',
    name: 'Added Today',
  },
  {
    filterType: 'AddedYesterday',
    name: 'Added Yesterday',
  },
];

export const DEFAULT_ONLINE_BAG_FILTERS = {
  AddedToday: false,
  AddedYesterday: false,
  ContainsSaleItem: false,
  ContainsPromotionalItem: false,
};

export const DEFAULT_SORT = 'itemsAddedDesc';
